export const validateEmail = new RegExp(
    "^[a-zA-Z0-9._:$!%-]+@[a-zA-Z0-9.-]+.[a-zA-Z]$"
);

export const validatePassword = new RegExp("^(?=.*\d.*\d)(?=.*[A-Z])(?=.*[@#$%\^&+=]).{8,}$");